import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTemplatesServicesGet = {
    path: "/templates/services",
    method: RouteHttpVerb.GET
};
